import { render, staticRenderFns } from "./Ventas_Admin.vue?vue&type=template&id=b8e6aeaa&scoped=true&"
import script from "./Ventas_Admin.vue?vue&type=script&lang=js&"
export * from "./Ventas_Admin.vue?vue&type=script&lang=js&"
import style0 from "./Ventas_Admin.vue?vue&type=style&index=0&id=b8e6aeaa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e6aeaa",
  null
  
)

export default component.exports